export const SUPPORTED_LANGUAGES = {
    th: 'th',
    'en-TH': 'en',
    'th-TH': 'th',
    en: 'en',
    'en-AU': 'en',
    'en-NZ': 'en',
    'en-PH': 'en',
    'en-MY': 'en',
    'en-HK': 'en',
    'en-SG': 'en',
    'en-ID': 'en',
    id: 'id',
    'id-ID': 'id',
    zh: 'zh',
    'zh-HK': 'zh'
};
//# sourceMappingURL=constants.js.map